<template>
  <v-btn
    class="dialog-button"
    :disabled="disabled"
    color="primary"
    @click="onClickExecute"
  >
    Execute
  </v-btn>
</template>

<script>
import {
  showConfirmDialog,
} from '@/mixins/utils';

export default {
  name: 'ExecuteButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    validationMethod: {
      // Pass any Function that need to execute before dialog opens
      // Function must returns a boolean
      type: Function,
      default: null
    },
  },
  methods: {
    execute() {
      this.$emit('confirm', {
        visibility: 'OnlyMe',
        group: null
      });
    },
    async onClickExecute() {
      if (this.validationMethod == null) {
        showConfirmDialog(
          'Execute',
          'Are you sure you want to execute this?',
          this.execute
        );
      } else if (typeof this.validationMethod === 'function') {
        const isValid = await this.validationMethod();
        if (isValid) {
          showConfirmDialog(
            'Execute',
            'Are you sure you want to execute this?',
            this.execute
          );
        }
      }
    }
  }
};
</script>

<style scoped>
.break{
  word-break: normal !important;
}
</style>
